const templateUrl = require('./unsent-shipment.html');

const app = angular.module('msi.shipments.unsentShipment', [
  require('../shipment.controller'),
  require('./unsent-shipment-list'),
  require('./unsent-shipment-body'),
  require('./unsent-shipment-footer'),
  require('./unsent-shipment-header')
]);

app.component('ogUnsentShipment', {
  bindings: {
    shipment: '<ogFor',
    showUpsell: '<ogShowUpsell'
  },
  controller: 'ShipmentController',
  templateUrl: templateUrl
});

module.exports = app.name;
